import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import foodDelivery from "../assets/food-delivery.png";
import groceries from "../assets/groceries.png";

const FoodDeliveryCards = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: "FOOD DELIVERY",
      subtitle: "FROM RESTAURANTS",
      offer: "UPTO 60% OFF",
      image: foodDelivery,
      route: "/", // or "/restaurants" if you have a restaurants page
    },
    {
      title: "GROCERIES",
      subtitle: "INSTANT GROCERY",
      offer: "UPTO 60% OFF",
      image: groceries,
      route: "/groceries", // target route
    },
  ];

  const handleCardClick = (route) => {
    navigate(route);
  };

  return (
    <section className="w-full bg-white px-4 py-10 sm:px-6 lg:px-10">
      <div className="mx-auto grid w-full grid-cols-1 gap-6 md:grid-cols-2 lg:gap-10">
        {cards.map((card, index) => (
          <div
            key={index}
            onClick={() => handleCardClick(card.route)}
            className="
              group
              relative
              !h-[300px]
              w-full
              min-w-0
              overflow-hidden
              rounded-[32px]
              bg-primary
              px-6
              py-6
              sm:px-8
              cursor-pointer
            "
          >
            {/* Content */}
            <div className="relative z-20">
              <h2
                className="
                  text-[24px]
                  font-bold
                  text-white
                  sm:text-[28px]
                  lg:text-[32px]
                "
              >
                {card.title}
              </h2>

              <p
                className="
                  mt-1.5
                  text-[16px]
                  font-medium
                  leading-tight
                  text-white/80
                  sm:text-[18px]
                  lg:text-[20px]
                "
              >
                {card.subtitle}
              </p>

              {/* Offer */}
              <div
                className="
                  mt-4
                  inline-flex
                  items-center
                  rounded-full
                  bg-gray-200
                  px-3
                  py-1.5
                "
              >
                <span
                  className="
                    text-[13px]
                    font-bold
                    leading-none
                    text-primary
                    sm:text-[14px]
                    lg:text-[15px]
                  "
                >
                  {card.offer}
                </span>
              </div>
            </div>

            {/* Arrow */}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation(); // prevent duplicate navigation if card also has onClick
                handleCardClick(card.route);
              }}
              className="
                absolute
                bottom-5
                left-6
                z-30
                flex
                h-[46px]
                w-[46px]
                items-center
                justify-center
                rounded-full
                bg-white
                text-primary
                transition-transform
                duration-300
                hover:scale-110
                sm:left-8
              "
            >
              <ArrowRight size={28} strokeWidth={2} />
            </button>

            {/* Image */}
            <div
              className="
                absolute
                -bottom-8
                right-0
                z-10
                flex
                h-full
                w-[65%]
                items-end
                justify-end
              "
            >
              <img
                src={card.image}
                alt={card.title}
                className="
                  h-full
                  w-full
                  object-contain
                  object-bottom
                  object-right
                  transition-transform
                  duration-500
                  group-hover:scale-105
                "
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FoodDeliveryCards;